export const DNAsimilaritymatrixdata = {
    'AA': 1,
    'CC': 1,
    'GG': 1,
    'TT': 1,
    'CA': -1,
    'GA': -1,
    'TA': -1,
    'GC': -1,
    'TC': -1,
    'TG': -1,
};
